<template>
<div @click="action">
  <p>{{text}}</p>
</div>
</template>

<script>
export default {
  name: 'underlined-button',
  props: {
    action: {
      type: Function,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

div {
  @include normalFontSize();
  @include borderRadius();
  font-weight: normal;
  border: 1px solid $grey;
  padding: 8px 17px;
  cursor: pointer;
}

p {
  text-align: center;
  line-height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/buttons/OutlinedButton.vue